
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default{
name: 'WxHeader',
data (){
return{
tag:'yawen',
showMenus: false,
showBackVal : true
}
},
components: {
Tabbar,
TabbarItem,
XHeader
},
created(){
this.tag = this.$route.name;



let order_ycode = '';
let route_path = this.$route.path;
if(route_path == '/'){
this.showBackVal = false;
}
if(route_path == '/PaymentDetail' && !!this.$route.query.order_ycode){
order_ycode = this.$route.query.order_ycode;
}
if(!order_ycode){
let is_login = this.is_login();
if(!is_login){

this.login_member_go_url();
}else{

let login_data = this.get_login_session_data();


let login_acc_url =  '/Login';

if(!!login_data.YZICode){

let MemberCheckUrl = '/MemberCheck';






if(route_path != MemberCheckUrl && (login_data.disabled != '0' || login_data.house_nums <= 0)){
this.$router.push({path: MemberCheckUrl});
}

let HouseMyUrl = '/HouseMy';
if(route_path != HouseMyUrl && login_data.house_id < 1 && login_data.house_nums > 1){
this.$router.push({path: HouseMyUrl});
}
}

if(!login_data.YZICode && route_path != login_acc_url){
this.$router.push({path: login_acc_url});
}
}
}

/* this.testgetLogindata();
this.init();
*/
},
mounted(){
},
methods: {
init(){
/*let local_url = location.href;
let wx_route_path = local_url.split('#')[1];
console.log(wx_route_path);
if(wx_route_path == '/WxLoginState/'){
let wx_code  = local_url.split('?')[1].split('=')[1];
let wx_state  = local_url.split('?')[1].split('=')[2];
let new_wx_state = wx_state.split('#')[0];
let url = local_url.split('?')[0]+'#'+wx_route_path+'?code='+wx_code+'='+new_wx_state;
console.log('url:'+url);
window.location.href = url;
}else{
let route_path = this.$route.path;
if(route_path != '/WxLoginState/'){
console.log('path::'+this.$route.path);
this.get_wx_code()
}
}*/
},
testgetLogindata(){
sessionStorage.check_login_data = ['no login'];
console.log(sessionStorage.check_login_data);
}
},
}



// WEBPACK FOOTER //
// ./src/components/Header.vue